// removed by extract-text-webpack-plugin
module.exports = {"meta":"'{\"e\":\".cat-desc\",\"f\":[]}'"};